import { API, Auth } from 'aws-amplify';
import { ServiceHealthHistory } from './getServicesHealthHistoryService';

export const query = /* GraphQL */ `
  query GetServicesHealthHistoryByBrands($brands: [Int], $services: [String], $from: AWSDateTime, $to: AWSDateTime) {
    getServicesHealthHistoryByBrands(brands: $brands, services: $services, from: $from, to: $to) {
      ... on GetServicesHealthHistoryByBrandsSuccess {
        __typename
        result {
          BrandsHealthHistory {
            Brand
            ServiceHealthHistory {
              Service
              History {
                date
                health
                healthPercentage
                failureRatio
                e2eTestsUpdatedAt
                healthUpdatedAt
              }
            }
          }
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export interface GetServicesHealthHistoryByBrandsVariables {
  brands?: number[];
  services?: string[];
  from?: string;
  to?: string;
}

interface PlatformHealthHistory {
  date: string;
  health: string;
  healthPercentage: number;
  failureRatio: number;
  e2eTestsUpdatedAt: string;
  healthUpdatedAt: string;
}

interface BrandsHealthHistory {
  Brand: string;
  PlatformHealthHistory: PlatformHealthHistory[];
  ServiceHealthHistory: ServiceHealthHistory[];
}

export interface GetServicesHealthHistoryByBrandsResult {
  BrandsHealthHistory: BrandsHealthHistory[];
}

interface GraphQLResponse {
  __typename: string;
  result?: GetServicesHealthHistoryByBrandsResult;
  message?: string;
  statusCode?: number;
}

async function getServicesHealthHistoryByBrandsService({
  brands,
  services,
  from,
  to,
}: GetServicesHealthHistoryByBrandsVariables): Promise<GetServicesHealthHistoryByBrandsResult> {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query,
      variables: {
        brands,
        services,
        from,
        to,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    }) as { data: { getServicesHealthHistoryByBrands: GraphQLResponse } };

    if (!postData.data) {
      throw new Error('Internal Server Error');
    }

    const response = postData.data.getServicesHealthHistoryByBrands;

    if (response.__typename === 'GetServicesHealthHistoryByBrandsSuccess' && response.result) {
      return response.result;
    }

    throw new Error(response.message || 'Unknown error occurred');
  } catch (error: any) {
    console.error('Error in getServicesHealthHistoryByBrands:', error);
    throw new Error(`Internal Server Error: ${error.errors ? error.errors[0].message : error.message}`);
  }
}

export default getServicesHealthHistoryByBrandsService;